import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import RecordVideo from "@/pages/RecordVideo";
import UploadVideo from "@/pages/UploadVideo";
import VideoPlayer from "@/pages/VideoPlayer";
import EmergentRedirect from "@/pages/EmergentRedirect";

import RequireAuth from "@/auth/RequireAuth";

function App() {
  useEffect(() => {
    const TEXT = "Made with Emergent";

    const removeByText = (root) => {
      const treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
      let node = treeWalker.currentNode;

      while (node) {
        try {
          const txt = (node.textContent || "").trim();
          if (txt.includes(TEXT)) node.remove();
        } catch (_) {}
        node = treeWalker.nextNode();
      }
    };

    const removeEmergentBadge = () => {
      try {
        document
          .querySelectorAll(
            '[source="emergent-badge"], [data-source="emergent-badge"], .emergent-badge, #emergent-badge'
          )
          .forEach((el) => el.remove());

        removeByText(document);

        document.querySelectorAll("*").forEach((el) => {
          if (el.shadowRoot) {
            removeByText(el.shadowRoot);
            el.shadowRoot
              .querySelectorAll(
                '[source="emergent-badge"], [data-source="emergent-badge"], .emergent-badge, #emergent-badge'
              )
              .forEach((x) => x.remove());
          }
        });
      } catch (_) {}
    };

    removeEmergentBadge();

    const interval = setInterval(removeEmergentBadge, 500);
    const obs = new MutationObserver(removeEmergentBadge);
    obs.observe(document.documentElement, { childList: true, subtree: true });

    return () => {
      clearInterval(interval);
      obs.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/Emergent" element={<EmergentRedirect />} />
          <Route path="/Emergent/*" element={<EmergentRedirect />} />

          {/* Protected */}
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/record"
            element={
              <RequireAuth>
                <RecordVideo />
              </RequireAuth>
            }
          />
          <Route
            path="/upload"
            element={
              <RequireAuth>
                <UploadVideo />
              </RequireAuth>
            }
          />
          <Route
            path="/video/:videoId"
            element={
              <RequireAuth>
                <VideoPlayer />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

